import { CobaltSearchField } from '@cae/cobalt-react/components/search-field';
import { useUsersFilter } from '@features/users/contexts/filter/useUsersFilter';
import { useSearchField } from '@shared/hooks/use-search-field/useSearchField';
import * as React from 'react';

import type { UsersSearchProps } from './UsersSearch.types';

import styles from './UsersSearch.module.css';

const UsersSearch = React.memo(
  ({ disabled = false }: Readonly<UsersSearchProps>): React.ReactElement => {
    const { filters, setFilters } = useUsersFilter();

    const { localValue, handleChange, handleClear } = useSearchField({
      value: filters.searchText,
      onSearch: (searchText: string) => setFilters({ searchText }),
    });

    return (
      <CobaltSearchField
        hasClear={true}
        placeholder="Search by name or email"
        value={localValue}
        onChange={handleChange}
        onClear={handleClear}
        disabled={disabled}
        className={styles.usersSearch}
        data-testid="users-search"
      />
    );
  }
);

UsersSearch.displayName = 'UsersSearch';

export { UsersSearch };
